import React from "react";
import logo from "../images/logo.svg";
import hero from "../images/Subscribe.svg";

import powerPostIllus from "../images/woman.svg";
import womanPowerIllus from "../images/verified.svg";
import simpleReach from "../images/simpleReach.svg";
import easyMonetization from "../images/easyMonetization.svg";
import ads from "../images/ads.svg";
import chat from "../images/chat.svg";
import privacy from "../images/privacy.svg";

import rishav from "../images/rishav.jpeg";
import mnjit from "../images/mnjit_blur.png";
import twitterLogo from "../images/twitter.svg";
import instalogo from "../images/instagram.svg";
import linkedinLogo from "../images/linkedin.svg";
import githubLogo from "../images/github.svg";
import facebooLogo from "../images/facebook.svg";
import logRed from "../images/logRed.svg";
import personalize from "../images/personalize.svg";

import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";

import firebase from "firebase";

function FeatureLeft(props) {
  return (
    <div>
      <div className="flex flex-wrap">
        <div className="w-5/6 sm:w-1/2 p-6">
          <h3 className="text-3xl text-gray-800 font-bold leading-none mb-3">
            {props.title}
          </h3>
          <p className="text-gray-600 mb-8 text-lg">{props.desc}</p>
        </div>
        <div className="w-full sm:w-1/2 p-6">
          <img src={props.image} alt="" />
        </div>
      </div>
    </div>
  );
}

function FeatureRight(props) {
  return (
    <div>
      <div className="flex flex-wrap flex-col-reverse sm:flex-row">
        <div className="w-full sm:w-1/2 p-6 ">
          <img src={props.image} alt="" />
        </div>
        <div className="w-full sm:w-1/2 p-6 mt-6">
          <div className="align-middle">
            <h3 className="text-3xl text-gray-800 font-bold leading-none mb-3">
              {props.title}
            </h3>
            <p className="text-gray-600 mb-8 text-lg">{props.desc}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

function TeamMember(props) {
  return (
    <div className="p-14 mt-5 sm:mt-0 bg-white w-full sm:w-auto rounded-md border flex items-center justify-center flex-col">
      <img src={props.pic} className="rounded-full w-40 h-40 mb-5" alt="" />
      <div className="font-bold font-robotoSlab flex items-center flex-col">
        <div className="text-2xl  text-gray-900 text-center">{props.name}</div>
        <div className="text-xl text-gray-700">{props.post}</div>
      </div>
      <div className="w-full mt-4">{props.children}</div>
    </div>
  );
}

function Index() {
  let [isOpen, setIsOpen] = useState(false);

  const [loggedIn, setloggedIn] = useState(false);

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  const signIn = () => {
    var firebaseConfig = {
      apiKey: "AIzaSyDfuGiQwH7B7Ue_zbY6edo_ZgFzjdDB7QM",
      authDomain: "reachfeed-subscriptions.firebaseapp.com",
      projectId: "reachfeed-subscriptions",
      storageBucket: "reachfeed-subscriptions.appspot.com",
      messagingSenderId: "1096939876658",
      appId: "1:1096939876658:web:0254296159084a956a272b",
      measurementId: "G-EY5JX5JCEJ",
    };
    // Initialize Firebase
    firebase.initializeApp(firebaseConfig);
    firebase.analytics();

    var provider = new firebase.auth.GoogleAuthProvider();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then((result) => {
        console.log(result);
        setIsOpen(true);
        setloggedIn(true);
      })
      .catch((err) => {
        alert("Unable to subscribe");
      });
  };

  return (
    <div className="leading-normal tracking-normal text-white gradient">
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-10 overflow-y-auto"
          onClose={closeModal}
        >
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-gray-900"
                >
                  Successfully registered
                </Dialog.Title>
                <div className="mt-2">
                  <p className="text-sm text-gray-500 text-center">
                    You have successfully pre-registred to Reachfeed. We will
                    notify you once we launch and you will be awarded an
                    exclusive "1st" badge.
                  </p>
                </div>

                <div className="mt-4">
                  <button
                    type="button"
                    className="inline-flex justify-center px-4 py-2 text-sm font-medium text-blue-900 bg-blue-100 border border-transparent rounded-md hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                    onClick={closeModal}
                  >
                    Got it, thanks!
                  </button>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>

      {/*Nav*/}
      <nav id="header" className="fixed w-full z-30 top-0 text-white">
        <div className="w-full container mx-auto flex flex-wrap items-center justify-between mt-0 py-2">
          <div className="pl-4 flex items-center">
            <a
              className="toggleColour text-white w-48 no-underline hover:no-underline font-bold text-2xl lg:text-4xl"
              href="#"
            >
              {/*Icon from: http://www.potlabicons.com/ */}
              <img src={logo} alt="" />
            </a>
          </div>
          <div className="block lg:hidden pr-4">
            <button
              id="nav-toggle"
              className="flex items-center p-1 text-pink-800 hover:text-gray-900 focus:outline-none focus:shadow-outline transform transition hover:scale-105 duration-300 ease-in-out"
            >
              <svg
                className="fill-current h-6 w-6"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>Menu</title>
                <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
              </svg>
            </button>
          </div>
          <div
            className="w-full flex-grow lg:flex lg:items-center lg:w-auto hidden mt-2 lg:mt-0 bg-white lg:bg-transparent text-black p-4 lg:p-0 z-20"
            id="nav-content"
          >
            <ul className="list-reset lg:flex justify-end flex-1 items-center font-bold">
              <li className="mr-3">
                <a
                  className="inline-block text-black no-underline hover:text-gray-800 hover:text-underline py-2 px-4"
                  href="#home"
                >
                  Home
                </a>
              </li>
              <li className="mr-3">
                <a
                  className="inline-block text-black no-underline hover:text-gray-800 hover:text-underline py-2 px-4"
                  href="#features"
                >
                  Features
                </a>
              </li>
              <li className="mr-3">
                <a
                  className="inline-block text-black no-underline hover:text-gray-800 hover:text-underline py-2 px-4"
                  href="#team"
                >
                  Team
                </a>
              </li>
            </ul>
          </div>
        </div>
        <hr className="border-b border-gray-100 opacity-25 my-0 py-0" />
      </nav>
      {/*Hero*/}
      <div className="pt-24" id="home">
        <div className="container px-3 mx-auto flex flex-wrap flex-col md:flex-row items-center">
          {/*Left Col*/}
          <div className="flex flex-col w-full md:w-2/5 justify-center items-start text-center md:text-left lg:pl-10">
            <h1 className="my-4 text-4xl font-bold leading-tight font-primaryFont">
              The social network that lets you Reach more for Less
            </h1>
            <p className="leading-normal  text-2xl mb-8 font-robotoSlab">
              Reachfeed is a social-networking platform that leads the creator
              community to organic grow with the help of there content.
            </p>

            <button
              onClick={signIn}
              disabled={loggedIn}
              className="mx-auto lg:mx-0 hover:underline bg-white text-gray-800 font-bold rounded-full my-6 py-4 px-8 shadow-lg focus:outline-none focus:shadow-outline transform transition hover:scale-105 duration-300 ease-in-out"
            >
              {loggedIn && "Already pre-registered"}
              {!loggedIn && "Pre-register now!!!"}
            </button>
          </div>
          {/*Right Col*/}
          <div className="w-full md:w-3/5 py-6 text-center floating">
            <img className="w-full md:w-4/5 z-50" src={hero} />
          </div>
        </div>
      </div>
      <div className="relative -mt-12 lg:-mt-24">
        <svg
          viewBox="0 0 1428 174"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            <g
              transform="translate(-2.000000, 44.000000)"
              fill="#FFFFFF"
              fillRule="nonzero"
            >
              <path
                d="M0,0 C90.7283404,0.927527913 147.912752,27.187927 291.910178,59.9119003 C387.908462,81.7278826 543.605069,89.334785 759,82.7326078 C469.336065,156.254352 216.336065,153.6679 0,74.9732496"
                opacity="0.100000001"
              />
              <path
                d="M100,104.708498 C277.413333,72.2345949 426.147877,52.5246657 546.203633,45.5787101 C666.259389,38.6327546 810.524845,41.7979068 979,55.0741668 C931.069965,56.122511 810.303266,74.8455141 616.699903,111.243176 C423.096539,147.640838 250.863238,145.462612 100,104.708498 Z"
                opacity="0.100000001"
              />
              <path
                d="M1046,51.6521276 C1130.83045,29.328812 1279.08318,17.607883 1439,40.1656806 L1439,120 C1271.17211,77.9435312 1140.17211,55.1609071 1046,51.6521276 Z"
                id="Path-4"
                opacity="0.200000003"
              />
            </g>
            <g
              transform="translate(-4.000000, 76.000000)"
              fill="#FFFFFF"
              fillRule="nonzero"
            >
              <path d="M0.457,34.035 C57.086,53.198 98.208,65.809 123.822,71.865 C181.454,85.495 234.295,90.29 272.033,93.459 C311.355,96.759 396.635,95.801 461.025,91.663 C486.76,90.01 518.727,86.372 556.926,80.752 C595.747,74.596 622.372,70.008 636.799,66.991 C663.913,61.324 712.501,49.503 727.605,46.128 C780.47,34.317 818.839,22.532 856.324,15.904 C922.689,4.169 955.676,2.522 1011.185,0.432 C1060.705,1.477 1097.39,3.129 1121.236,5.387 C1161.703,9.219 1208.621,17.821 1235.4,22.304 C1285.855,30.748 1354.351,47.432 1440.886,72.354 L1441.191,104.352 L1.121,104.031 L0.457,34.035 Z" />
            </g>
          </g>
        </svg>
      </div>
      <section className="bg-white border-b py-8" id="features">
        <div className="container max-w-5xl mx-auto m-8">
          <h1 className="w-full my-2 text-5xl font-primaryFont font-bold leading-tight text-center text-gray-800">
            Features
          </h1>
          <div className="w-full mb-4">
            <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t" />
          </div>

          <div className="flex gap-4 flex-col">
            <FeatureLeft
              title="Power Post"
              desc="New format of a post which we call 'power post' which lets you
                add a voicenote to A picture or a blank post because we believe
                in power of the people's voice"
              image={powerPostIllus}
            ></FeatureLeft>

            <FeatureRight
              title="Woman Safety"
              desc="Women get the upper hand in direct messaging as all the female
                  (or other) profiles Can direct message someone but the male
                  profile need to send a text request Before the actual dm"
              image={womanPowerIllus}
            ></FeatureRight>

            <FeatureLeft
              title="Simple Reach"
              desc="Local/new creators get chance to reach a broader audience than any other
Platform as we don't use any algorithms and all post are synchronized based on
Interests on the feed with preference to local and national creators. 
"
              image={simpleReach}
            ></FeatureLeft>

            <FeatureRight
              title="Easy monetization "
              desc="Now just like on livestream, creators can monetize each one of their posts through
The app itself and can earn money through super-stickers or direct donations.
Users can monetize their posts for a nominal fee and earn from their posts directly. 
"
              image={easyMonetization}
            ></FeatureRight>

            <FeatureLeft
              title="Run affordable ads"
              desc="Local and global businesses can create business profiles and also provide ads at
Minimum costs to showcase their products and target customers who have the
Same interests as their product so that they can reach their viable audience in
Less time. ."
              image={ads}
            ></FeatureLeft>

            <FeatureRight
              title="Chat Based Forum "
              desc="A chat-based forum which lets users sharing same interest(s) to interact with each
Other through a chat based format which builds more connection than group-posts. "
              image={chat}
            ></FeatureRight>

            <FeatureLeft
              title="No Privacy Issues"
              desc="Gone Are The Days Of Worrying About Data Tracking And Outside-App Usage As We
Believe In Your Privacy And Will Only Track Your Interests And Your In-App Normal
Usage. "
              image={privacy}
            ></FeatureLeft>

            <FeatureRight
              title="Personalized feed"
              desc="A personalized feed to cater to only those interest/ topics which interests you
Rather than wasting time on random posts and reduce the time we waste in
Aimless scrolling on our feed."
              image={personalize}
            ></FeatureRight>
          </div>
        </div>
      </section>
      <section className="bg-white border-b py-8" id="team">
        <div className="container mx-auto flex flex-wrap pt-4 pb-12">
          <h1 className="w-full my-2 text-4xl md:text-5xl font-primaryFont font-bold leading-tight text-center text-gray-800">
            Meet our team
          </h1>
          <div className="w-full mb-4">
            <div className="h-1 mx-auto gradient w-44 md:w-64 opacity-25 my-0 py-0 rounded-t" />
          </div>
          <div className="sm:flex sm:justify-evenly mt-5 sm:flex-row m-3 sm:items-center w-full">
            <TeamMember pic={rishav} name="Rishav Kundu" post="Founder | CEO">
              <div className="flex w-full justify-evenly flex-row">
                <a
                  href="https://www.linkedin.com/in/rishav-kundu-a769b7112"
                  className="transform hover:scale-125"
                >
                  <img src={linkedinLogo} className="w-6  h-6" alt="" />
                </a>
                <a
                  href=" https://twitter.com/rishavrk4k"
                  className="transform hover:scale-125"
                >
                  <img src={twitterLogo} className="w-6  h-6" alt="" />
                </a>
                <a
                  href="https://instagram.com/iamrishavk"
                  className="transform hover:scale-125"
                >
                  <img src={instalogo} className="w-6  h-6" alt="" />
                </a>
                <a
                  href="https://www.facebook.com/rishavk.9840"
                  className="transform hover:scale-125"
                >
                  <img src={facebooLogo} className="w-6  h-6" alt="" />
                </a>
              </div>
            </TeamMember>

            <TeamMember
              pic={mnjit}
              name="Manjit Pardeshi"
              post="Co-founder | CTO"
            >
              <div className="flex w-full justify-evenly flex-row">
                <a
                  href="https://www.linkedin.com/in/manjit-pardeshi-9174651b2"
                  className="transform hover:scale-125"
                >
                  <img src={linkedinLogo} className="w-6  h-6" alt="" />
                </a>
                <a
                  href="https://twitter.com/ManjitPardeshi2"
                  className="transform hover:scale-125"
                >
                  <img src={twitterLogo} className="w-6  h-6" alt="" />
                </a>
                <a
                  href="https://instagram.com/manjit.pardeshi"
                  className="transform hover:scale-125"
                >
                  <img src={instalogo} className="w-6  h-6" alt="" />
                </a>
                <a
                  href="https://github.com/Manjit2003"
                  className="transform hover:scale-125"
                >
                  <img src={githubLogo} className="w-6  h-6" alt="" />
                </a>
              </div>
            </TeamMember>
          </div>
        </div>
      </section>
      {/* Change the colour #f8fafc to match the previous section colour */}
      <svg
        className="wave-top"
        viewBox="0 0 1439 147"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <g transform="translate(-1.000000, -14.000000)" fillRule="nonzero">
            <g className="wave" fill="#f8fafc">
              <path d="M1440,84 C1383.555,64.3 1342.555,51.3 1317,45 C1259.5,30.824 1206.707,25.526 1169,22 C1129.711,18.326 1044.426,18.475 980,22 C954.25,23.409 922.25,26.742 884,32 C845.122,37.787 818.455,42.121 804,45 C776.833,50.41 728.136,61.77 713,65 C660.023,76.309 621.544,87.729 584,94 C517.525,105.104 484.525,106.438 429,108 C379.49,106.484 342.823,104.484 319,102 C278.571,97.783 231.737,88.736 205,84 C154.629,75.076 86.296,57.743 0,32 L0,0 L1440,0 L1440,84 Z" />
            </g>
            <g transform="translate(1.000000, 15.000000)" fill="#FFFFFF">
              <g transform="translate(719.500000, 68.500000) rotate(-180.000000) translate(-719.500000, -68.500000) ">
                <path
                  d="M0,0 C90.7283404,0.927527913 147.912752,27.187927 291.910178,59.9119003 C387.908462,81.7278826 543.605069,89.334785 759,82.7326078 C469.336065,156.254352 216.336065,153.6679 0,74.9732496"
                  opacity="0.100000001"
                />
                <path
                  d="M100,104.708498 C277.413333,72.2345949 426.147877,52.5246657 546.203633,45.5787101 C666.259389,38.6327546 810.524845,41.7979068 979,55.0741668 C931.069965,56.122511 810.303266,74.8455141 616.699903,111.243176 C423.096539,147.640838 250.863238,145.462612 100,104.708498 Z"
                  opacity="0.100000001"
                />
                <path
                  d="M1046,51.6521276 C1130.83045,29.328812 1279.08318,17.607883 1439,40.1656806 L1439,120 C1271.17211,77.9435312 1140.17211,55.1609071 1046,51.6521276 Z"
                  opacity="0.200000003"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
      <section className="container mx-auto text-center py-6 mb-12">
        <h1 className="w-full my-2 text-4xl md:text-5xl font-bold leading-tight text-center font-primaryFont text-white">
          Pre-register Now
        </h1>
        <div className="w-full mb-4">
          <div className="h-1 mx-auto bg-white w-1/6 opacity-25 my-0 py-0 rounded-t" />
        </div>
        <h3 className="my-4 text-2xl leading-tight font-robotoSlab">
          Pre-register and get an exclusive "1st" badge
        </h3>
        <button
          onClick={signIn}
          disabled={loggedIn}
          className="mx-auto lg:mx-0 hover:underline bg-white text-gray-800 font-bold rounded-full my-6 py-4 px-8 shadow-lg focus:outline-none focus:shadow-outline transform transition hover:scale-105 duration-300 ease-in-out"
        >
          {loggedIn && "Already pre-registered"}
          {!loggedIn && "Pre-register today!!!"}
        </button>
      </section>
      {/*Footer*/}
      <footer className="bg-white">
        <div className="container mx-auto px-8">
          <div className="w-full flex flex-col md:flex-row py-6">
            <div className="flex-1 mb-6 text-black">
              <a
                className="toggleColour text-white w-48 no-underline hover:no-underline font-bold text-2xl lg:text-4xl"
                href="#home"
              >
                {/*Icon from: http://www.potlabicons.com/ */}
                <img src={logRed} alt="" />
              </a>
            </div>
            <div className="flex-1">
              <p className="uppercase text-gray-500 md:mb-6">Links</p>
              <ul className="list-reset mb-6">
                <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                  <a
                    href="#"
                    className="no-underline hover:underline text-gray-800 hover:text-pink-500"
                  >
                    FAQ
                  </a>
                </li>
                <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                  <a
                    href="#"
                    className="no-underline hover:underline text-gray-800 hover:text-pink-500"
                  >
                    Help
                  </a>
                </li>
                <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                  <a
                    href="#"
                    className="no-underline hover:underline text-gray-800 hover:text-pink-500"
                  >
                    Support
                  </a>
                </li>
              </ul>
            </div>
            <div className="flex-1">
              <p className="uppercase text-gray-500 md:mb-6">Legal</p>
              <ul className="list-reset mb-6">
                <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                  <a
                    href="#"
                    className="no-underline hover:underline text-gray-800 hover:text-pink-500"
                  >
                    Terms
                  </a>
                </li>
                <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                  <a
                    href="#"
                    className="no-underline hover:underline text-gray-800 hover:text-pink-500"
                  >
                    Privacy
                  </a>
                </li>
              </ul>
            </div>
            <div className="flex-1">
              <p className="uppercase text-gray-500 md:mb-6">Social</p>
              <ul className="list-reset mb-6">
                <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                  <a
                    href="#"
                    className="no-underline hover:underline text-gray-800 hover:text-pink-500"
                  >
                    Facebook
                  </a>
                </li>
                <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                  <a
                    href="#"
                    className="no-underline hover:underline text-gray-800 hover:text-pink-500"
                  >
                    Linkedin
                  </a>
                </li>
                <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                  <a
                    href="#"
                    className="no-underline hover:underline text-gray-800 hover:text-pink-500"
                  >
                    Twitter
                  </a>
                </li>
              </ul>
            </div>
            <div className="flex-1">
              <p className="uppercase text-gray-500 md:mb-6">Company</p>
              <ul className="list-reset mb-6">
                <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                  <a
                    href="#"
                    className="no-underline hover:underline text-gray-800 hover:text-pink-500"
                  >
                    Official Blog
                  </a>
                </li>
                <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                  <a
                    href="#"
                    className="no-underline hover:underline text-gray-800 hover:text-pink-500"
                  >
                    About Us
                  </a>
                </li>
                <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                  <a
                    href="#"
                    className="no-underline hover:underline text-gray-800 hover:text-pink-500"
                  >
                    Contact
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="flex justify-center items-center p-4 text-base text-gray-800">
          <a href="#">Made with ❤️ by Manjit Pardeshi</a>
        </div>
      </footer>
      {/* jQuery if you need it
  
  */}
    </div>
  );
}

export default Index;
